import { SortOrderSchema } from '@duke-hq/lib/pagination';
import { AdminUserRole } from '@duke-hq/shared-constants/admin';
import { z } from 'zod';

export const SortFiltersSchema = z.object({
  role: z.custom<AdminUserRole>().optional(),
  orderBy: z.string().optional(),
  sort: SortOrderSchema.optional(),
});

export type SortFilters = z.infer<typeof SortFiltersSchema>;
